import api from './api';

const authService = {
  checkSubdomain: (subdomain) => api.post('/auth/check-subdomain', { subdomain }),
  checkPhone: (phone) => api.post('/auth/check-phone', { phone }),
  sendRegisterOtp: (data) => api.post('/auth/register/send-otp', data),
  verifyRegisterOtp: (data) => api.post('/auth/register/verify-otp', data),
  completeRegistration: (data) => api.post('/auth/register/complete', data),
  login: (email, password, captchaToken) =>
    api.post('/auth/login', { email, password, captchaToken: captchaToken || undefined }),
  getCaptchaConfig: () => api.get('/auth/captcha-config'),
  forgotPasswordSendOtp: (email) => api.post('/auth/forgot-password/send-otp', { email }),
  forgotPasswordVerifyOtp: (email, otp) => api.post('/auth/forgot-password/verify-otp', { email, otp }),
  resetPassword: (data) => api.post('/auth/forgot-password/reset', data),
  refreshToken: () => api.post('/auth/refresh-token'),
  logout: () => api.post('/auth/logout'),
};

export default authService;
